import React, { useState, useEffect } from "react";
import * as helpers from "../../utils/utils"

const ArrivalTimeForm = ({ initialData = {}, onSubmit, min, max }) => {
  const [arrivalTime, setArrivalTime] = useState({});

  const isValidTime = (time) => {
    return time >= min && time <= max;
  };

  const timeError = !isValidTime(arrivalTime);

  useEffect(() => {
    console.log(arrivalTime)
  }, [arrivalTime])

  useEffect(() => {
    setArrivalTime(initialData);
  }, [initialData]);

  const submit = (e) => {
    e.preventDefault();
    if (timeError) return;
    onSubmit(arrivalTime);
  }

  const reset = (e) => {
    e.preventDefault();
    setArrivalTime(initialData)
  }

  return (
    <form className="p-3 border rounded">
      <p className="mb-2">
        Please enter your expected arrival time so we can have your boat ready and get you on the water as quickly as possible.
      </p>

      <div className="mb-2">
        <label className="form-label">Arrival Time</label>
        <input
          type="time"
          className={`form-control ${timeError ? "is-invalid" : ""}`}
          value={arrivalTime}
          onChange={(e) => setArrivalTime(e.target.value)}
          min={min}
          max={max}
        />
        {timeError && (
          <div className="invalid-feedback">
            Please enter a time between {min} and {max}.
          </div>
        )}
      </div>

      <div className='modal-btn-container'>

          <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
          <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>

    </form>

    
  );
};

export default ArrivalTimeForm;
